<template>
    <Layout>
        <div class="row">
            <div class="col-md-12">
                <b-card v-if="Object.keys(ses_info).length !== 0">
                    <h5 class="font-bold">Power EP Information</h5>
                    <div class="form-row">
                        <div class="col-md-6 col-sm-6 col-lg-4"><b>EP ID:</b> <span v-if="ses_info.ses.ep_id !== null">{{ ses_info.ses.ep_id.ep_id}}</span></div>
                        <div class="col-md-6 col-sm-6 col-lg-6"><b>NID: </b>{{ ses_info.ses.nid }}</div>
                    </div>
                    <div class="form-row">
                        <div class="col-md-6 col-sm-6 col-lg-4"><b>Name of the EP:</b> {{ ses_info.ses.name }}</div>
                        <div class="col-md-6 col-sm-6 col-lg-6"><b>Father/Husband Name:</b> {{ ses_info.ses.father_husband_name }}</div>
                    </div>
                    <div class="form-row">
                        <div class="col-md-6 col-sm-6 col-lg-4"><b>Mouza: </b>{{ ses_info.ses.mouza.mouza_desc }}</div>
                        <div class="col-md-6 col-sm-6 col-lg-6"><b>Union/City Coorporation:</b> {{ ses_info.ses.union.union_desc }}</div>
                        <div class="col-md-6 col-sm-6 col-lg-2">
                            <router-link :to="{ name: 'sesPowerGroupList', params: { ses_id: ses_info.ses.id } }"  class="btn btn-sm btn-danger"
                                         tag="a" > Back to Parent EP
                            </router-link>
                        </div>
                    </div>
                </b-card>

                <b-card>
                    <a v-if="userPermission.includes('child-ep-create')" @click.prevent="childEpAddToGroupModal" class="btn btn-success btn-sm mb-1"
                       href="javascript:void(0);" title="Add more EP to this group">
                        <i class="fa fa-plus"></i> Add New EP
                    </a>
                    <div class="table-responsive" style="overflow-x: auto">
                        <table class="table table-centered table-striped">
                            <thead>
                            <tr>
                                <th>Sl</th>
                                <th>EP ID</th>
                                <th>Name</th>
                                <th>Father's Name</th>
                                <th>Group ID</th>
                                <th>Action</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(child_group, index) in child_groups" :key="index">
                                <td>{{ index + 1}}</td>
                                <td><span v-if="child_group.ses.ep_id !== null">{{ child_group.ses.ep_id.ep_id }}</span></td>
                                <td>{{ child_group.ses.name }}</td>
                                <td>{{ child_group.ses.father_husband_name }}</td>
                                <td>{{ child_group.power_group_id}}</td>
                                <td>
<!--                                    <a v-if="(child_group.ses.ep_id.payment_vouchers.length === 0)" @click.prevent="deleteChildEpFromGroup(child_group.id)" class="action-icon"-->
                                    <span v-if="ses_info.payment_vouchers.length == 0">
                                      <a v-if="userPermission.includes('child-ep-delete')" @click.prevent="deleteChildEpFromGroup(child_group.id)" class="action-icon"
                                         href="javascript:void(0);" title="Delete EP From Group">
                                        <i class="mdi mdi-delete deleteButton"></i>
                                    </a>
                                    </span>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <h5 class="text-center text-secondary" v-if="child_groups.length === 0">
                            No Data Found
                        </h5>
                    </div>
                </b-card>
            </div>
        </div>
        <child-ep-add-to-group-modal
        :child_ep="child_ep"
        @getParentGroupList="getParentGroupList">
        </child-ep-add-to-group-modal>
    </Layout>
</template>

<script>
    import appConfig from "@src/app.config";
    import Layout from "@layouts/main";
    import PageHeader from "@components/page-header";
    import http from "@state/http";

    import childEpAddToGroupModal from "@views/data/modals/childEpAddToGroupModal";

    export default {
        page: {
            title: "SES List",
            meta: [{name: "description", content: appConfig.description}]
        },
        components: {Layout, PageHeader, childEpAddToGroupModal},
        data() {
            return {
                child_groups: [],
                ses_info: {},
                child_ep: {},
            };
        },

        mounted() {
            this.getParentGroupList();
        },
        methods: {
             getParentGroupList(){
                let power_group_id = this.$route.params.power_group_id;
                 http.get("api/ses/power/child/group/list/" + power_group_id)
                    .then(response => {
                        this.child_groups = response.data.child_groups
                        this.ses_info = response.data.ses_info
                });
            },
             childEpAddToGroupModal() {
                 let power_group_id = this.$route.params.power_group_id;
                 this.child_ep = {}
                 this.child_ep.power_group_id = power_group_id
                 this.$root.$emit("bv::show::modal", "child-ep-add-to-group-modal");
            },

            deleteChildEpFromGroup(id){
                if (confirm("Do you really want to delete?")) {
                    http.delete("api/ses/power/child/group/" + id).then(response => {
                        if (!response.error) {
                            if(response.data.error === true){
                                this.$bvToast.toast(response.data.message, {
                                    title: "Error",
                                    autoHideDelay: 5000,
                                    variant: "danger"
                                });
                            }else{
                                this.$bvToast.toast(response.data.message, {
                                    title: "Success",
                                    autoHideDelay: 5000,
                                    variant: "success"
                                });
                                this.getParentGroupList();
                            }
                        } else {
                            this.$bvToast.toast("Deleted Failed", {
                                title: "Error",
                                autoHideDelay: 5000,
                                variant: "danger"
                            });
                        }
                    });
                }
            }
        },
        computed: {
            userPermission () {
                return this.$store.state.user
            }
        },
        created () {
            this.$store.dispatch('getUserPermission')
        },
    };
</script>
